import service from "@/utils/service"

export function getConfigs(params){
    return service.get('/conf',{
        params,
    })
}